import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectedGradeStateService {
  static readonly selectedGrade$: BehaviorSubject<number> = new BehaviorSubject(
    null,
  );
  get gradeId(): number {
    return SelectedGradeStateService.selectedGrade$.getValue();
  }
  get currentGrade$(): Observable<number> {
    return SelectedGradeStateService.selectedGrade$.asObservable();
  }
  set selectedGrade(gradeLevel: string) {
    switch (gradeLevel) {
      case 'TK':
      case 'tk':
        SelectedGradeStateService.selectedGrade$.next(0);
        break;
      case 'K':
      case 'k':
        SelectedGradeStateService.selectedGrade$.next(1);
        break;
      default:
        SelectedGradeStateService.selectedGrade$.next(1 + +gradeLevel);
        break;
    }
  }
}
